import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { MotionConfig } from "framer-motion";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import BackToTop from "@/components/BackToTop";
import AnnouncementBar from "@/components/AnnouncementBar";
import { ContentContext, defaultContent } from "@/data/siteContent";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import Pricing from "@/pages/Pricing";
import Work from "@/pages/Work";
import Quikpik from "@/pages/Quikpik";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import Admin from "@/pages/Admin";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: pathname, page_title: document.title });
    }
  }, [pathname]);
  return null;
};

function App() {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    const envUrl = process.env.REACT_APP_BACKEND_URL;
    const base = envUrl && new URL(envUrl).host === window.location.host ? envUrl : window.location.origin;
    axios
      .get(`${base}/api/content`)
      .then((r) => {
        if (r.data && typeof r.data === "object") {
          setContent({ ...defaultContent, ...r.data, contact: { ...defaultContent.contact, ...(r.data.contact || {}) }, quikpik: { ...defaultContent.quikpik, ...(r.data.quikpik || {}) }, announcement: { ...defaultContent.announcement, ...(r.data.announcement || {}) }, home_chips: { ...defaultContent.home_chips, ...(r.data.home_chips || {}) } });
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div className="App">
      <HelmetProvider>
        <MotionConfig reducedMotion="user">
          <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
            <ContentContext.Provider value={content}>
            <BrowserRouter>
              <ScrollToTop />
              <div className="grain-overlay" aria-hidden="true" />
              <AnnouncementBar />
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/services/:slug" element={<ServicePage />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/work" element={<Work />} />
                  <Route path="/quikpik" element={<Quikpik />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
                  <Route path="/terms" element={<LegalPage slug="terms" />} />
                  <Route path="/refund-policy" element={<LegalPage slug="refund-policy" />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppFloat />
              <BackToTop />
              <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#101313", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
            </BrowserRouter>
            </ContentContext.Provider>
          </ReactLenis>
        </MotionConfig>
      </HelmetProvider>
    </div>
  );
}

export default App;
